/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-18 10:02:53
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 14:53:57
 * @FilePath: /chaoyongtuan/src/views/teamManage/delegationHead/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

const institutionName = {
  key: 'institution_name',
	label: '团长名称',
	type: ColumnTypes.TextCell,
	minWidth: '200',
	fixed: 'left',
}
const institutionID = {
  key: 'authority_id',
	label: '团长ID',
	type: ColumnTypes.TextCell,
	minWidth: '200',
	fixed: 'left',
}
const status = {
  key: 'status',
	label: '授权状态',
	type: () => import('./components/tableCells/statusCells.vue'),
	minWidth: '130',
  fixed: 'left',
	sortable: 'status',
}
const productNum = {
  key: 'product_num',
	label: '商品总数',
	type: ColumnTypes.TextCell,
	minWidth: '130',
  fixed: 'left',
	sortable: 'product_num',
}
const addTime = {
  key: 'add_time',
	label: '授权时间',
	type: () => import('./components/tableCells/timerCells.vue'),
	minWidth: '170',
  fixed: 'left',
}


const operations = {
  key: 'operations',
	label: '操作',
  type: ColumnTypes.ButtonsCell,
	minWidth: '310',
	align: 'right',
	mode: 'vertical',
	fixed: 'right',
}

export const columns = [
	institutionName,
  institutionID,
  status,
  productNum,
  addTime,
	operations,
];
